<template>
    <div class="betterio">
        <h1 class="name-team">Betterio</h1>

        <h1 class="">
            <h1 class="name-template name-template1">Invoice</h1>
            <h1 class="name-template">template</h1>
        </h1>

        <h3>File Format Contains:</h3>

        <div class="type-file">
            <download-excel
                    class="btn btn-default"
                    :data="this.products"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    name="invoice-products.xls">

                <a><img src="../assets/img/excel.png"></a>
                <a href=""><img src="../assets/img/word.png"></a>

            </download-excel>

        </div>


    </div>

</template>

<script>

    import DownloadExcel from "./JsonExcel.vue"

    export default {
        data: () => ({

            json_fields: {
                product_name: 'name',
                price: 'price',
                quantity: 'quantity',

            },

            json_meta: [
                [
                    {
                        key: 'charset',
                        value: 'utf-8'
                    }
                ]
            ],

        }),

        components: {
            DownloadExcel
        },
        props: ["products"]
    }


</script>


<style scoped>
    img {
        width: 50px;
        height: auto;
        margin-right: 20px;
        margin-top: 20px;
    }

    h3 {
        font-weight: unset;
    }

    .name-team {
        font-size: 30px;
        font-weight: 600;
        margin-bottom: 0px;
    }

    .name-template {
        font-size: 60px;
        font-weight: unset;
        font-family: "Candara Light";
        margin-bottom: 70px;
    }

    .name-template {
        font-size: 60px;
        font-weight: unset;
        font-family: "Candara Light";
    }

    .name-template1 {
        margin-bottom: -30px;
    }


    .betterio {
        color: white;
        position: fixed;
        padding: 0 0px;
        margin: 15% 7%;
        display: inline-block;
        text-align: left;
        justify-self: left;

    }
</style>